import type { FC } from "react";

import classes from "./AddPodForm.module.css";
import type { AddPodFormProps } from "./AddPodForm.types";
import { ContractCard } from "../ContractCard/ContractCard";
import { PodInfoCard } from "../PodInfoCard/PodInfoCard";
import { RequestedBenefitCard } from "../RequestedBenefitCard/RequestedBenefitCard";
import { TariffOptionsCard } from "../TariffOptionsCard/TariffOptionsCard";
import { TechnicalContactCard } from "../TechnicalContactCard/TechnicalContactCard";

export const AddPodForm: FC<AddPodFormProps> = ({
  data,
  errors,
  control,
  setValue,
}) => (
  <div className={classes.container}>
    <PodInfoCard control={control} errors={errors} responseData={data} />
    <RequestedBenefitCard control={control} errors={errors} />
    <TariffOptionsCard control={control} errors={errors} />
    <ContractCard control={control} errors={errors} setValue={setValue} />
    <TechnicalContactCard control={control} errors={errors} />
  </div>
);
